import { createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../network/api";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    login: false,
    user: "",
    LoginURL:
      API_URL,
  },
  reducers: {
    loginSuccess: (state) => {
      state.login = true;
    },
    addUser: (state, action) => {
      console.log(action.payload);
      state.user = action.payload;
    },
    logoutSuccess: (state) => {
      state.login = false;
      state.user = "";
    },
  },
});

export const { loginSuccess, addUser, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;
